import { Component } from 'preact';
import { withRouter } from 'react-router-dom';
import MetaTags from 'react-meta-tags';
import qs from 'query-string';

import Layout from '../../components/Layout';
import SecuredPaymentInfo from '../../components/blocks/raffleForm/SecuredPaymentInfo';
import RaffleForm from '../raffle/RaffleForm';
import LoadingSpinner from '../../components/spinner/LoadingSpinner';

@withRouter
class PaymentRepeating extends Component {
	componentWillMount() {
		const { registrationId } = this.props.match.params;

		const params = qs.parse(this.props.location.search);

		const error = params.error || 'We were unable to process the payment';

		if (registrationId) {
			this.props.getRepeatPaymentData(registrationId, error);
		}
	}

	render() {
		const { route, location, match, registration, payment } = this.props;

		const { repeatPaymentError } = payment;

		if (this.props.payment.config.clientKey) {
			return (
				<RaffleForm
					match={match}
					route={route}
					location={location}
					registration={registration} />
			);
		}

		return (
			<Layout {...{ route, location }}>
				<MetaTags>
					<title>{route.metaTitle}</title>
					<meta name="description" content="" />
				</MetaTags>
				<SecuredPaymentInfo />
				<div className={`text-center p-4 w-100`}>
					{repeatPaymentError && !!repeatPaymentError.length ? (
						<div>
							<h2>An error has occurred</h2>
							<div className={`alert alert-danger text-left mt-3`} role="alert">
								{repeatPaymentError.map((err, index) => (
									<div key={index}>{err}</div>
								))}
							</div>
						</div>
					) : (
						<LoadingSpinner active />
					)}
				</div>
			</Layout>
		);
	}
}

export default PaymentRepeating;



// WEBPACK FOOTER //
// ./routes/paymentRepeating/component.js